import { useEffect } from "react";
import type mapboxgl from "mapbox-gl";

// The seed overlay owns the 4px/1px eye borders. Do not let the shared map's
// underlying 2px grid lines make a crossed-out eye still look 2px wide.
const useSeedBaseBorders = (
  map: mapboxgl.Map | null,
  enabled: boolean
): void => {
  useEffect(() => {
    if (!map || !enabled) return;
    const previousOpacities = new Map<string, unknown>();
    const suppress = (): void => {
      for (const layer of map.getStyle()?.layers ?? []) {
        if (
          layer.type !== "line" ||
          typeof layer.source !== "string" ||
          !/^(?:cloned-)?grid-of-trial-plots-/.test(layer.source)
        ) {
          continue;
        }
        const opacity = map.getPaintProperty(layer.id, "line-opacity");
        if (opacity !== 0) {
          previousOpacities.set(layer.id, opacity);
          map.setPaintProperty(layer.id, "line-opacity", 0);
        }
      }
    };
    suppress();
    map.on("styledata", suppress);
    return () => {
      map.off("styledata", suppress);
      if (!map.getStyle()) return;
      previousOpacities.forEach((opacity, id) => {
        if (map.getLayer(id)) {
          map.setPaintProperty(id, "line-opacity", opacity ?? null);
        }
      });
    };
  }, [map, enabled]);
};

export default useSeedBaseBorders;
